module.exports = __webpack_public_path__ + "img/banner3_5_kr.0ee2c710.png";